import type { TOC } from '@ember/component/template-only';
import { eq, or } from 'ember-truth-helpers';
import { local } from 'embroider-css-modules';

import type { BadgeType } from '../../types/components/prism/badge.ts';
import type { IconName } from '../../types/components/prism/icon.ts';
import styles from './badge.module.css';
import PrismIcon from './icon.gts';

interface PrismBadgeSignature {
  Args: {
    iconName?: IconName;
    isSmall?: boolean;
    label?: number | string;
    type?: BadgeType;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const PrismBadge: TOC<PrismBadgeSignature> = <template>
  <div
    class={{local
      styles
      "prism-badge"
      (or @type "neutral")
      (if @isSmall "is-small")
    }}
    data-test-badge={{if (eq @label undefined) "" @label}}
    ...attributes
  >
    {{#if @iconName}}
      <PrismIcon @color="inherit" @name={{@iconName}} @size="small" />
    {{/if}}

    {{#if (eq @label undefined)}}
      {{yield}}
    {{else}}
      {{@label}}
    {{/if}}
  </div>
</template>;

export default PrismBadge;
